import { render, staticRenderFns } from "./DataGridLink.vue?vue&type=template&id=169e85ef&scoped=true&functional=true&"
import script from "./DataGridLink.vue?vue&type=script&lang=ts&"
export * from "./DataGridLink.vue?vue&type=script&lang=ts&"
import style0 from "./DataGridLink.vue?vue&type=style&index=0&id=169e85ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "169e85ef",
  null
  
)

export default component.exports